module.exports = __webpack_public_path__ + "img/excel.879a148b.png";